<template>
    <div class="modal-overlay" @click="$emit('close')">
        <div class="modal" ref="myBtn" @click="$emit('close')">
            <div>
                <p class="cssMessage mb-1">{{message}}</p>
            </div>
            <div class="text-center">
                <label class="mb-2 cssMessage">Please Enter the Question Title</label>
                <input type="text" :value ="this.template.questions[this.qKey].title" @input="changeInputTitle" maxlength="20" class="form-control custom-input" />
            </div>
            <br>
            <div class="d-flex gap-3">
                <button class="confirm-btn" @click="confirmHandler">Ok</button>
                <button class="confirm-btn" @click="cancleHandler">Cancel</button>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name:'modalEdit-component',
        props: ['message' , 'qKey' , 'template'],
        data(){
            return {
                state: false,
                titleQuestion:null
            }
        },
        methods:{
            async confirmHandler(){
                this.template.questions[this.qKey].title = this.titleQuestion;
                this.$emit('saveTitle', this.template.questions[this.qKey].title);
            },
            async changeInputTitle (e){
                console.log(this.qKey);
                console.log(this.template);
                this.titleQuestion = e.target.value;
                // this.template.questions[this.qKey].title = e.target.value;
            },
            cancleHandler(){
                this.$emit('close-modal' , false)
            }
        }

    }
</script>

<style scoped>

    .cssMessage{
        color: var(--text-color-in-Confirm-immed);
    }

    .custom-input{
        background-color: transparent;
        color: var(--main-color);
        padding: 10px;
        width: 100%;
    }
    .custom-input:focus{
        background-color: transparent;
        color: var(--main-color);
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000;
        z-index: 100;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: unset !important;
        background-color: var(--background-color-input-create);
        height: 300px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .confirm-btn{
        background-color: var(--btn-bg-color);
        border: 1px solid transparent;
    }
    .cancle-btn{
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
</style>